import { connect } from 'react-redux';
import { selectRouteParams } from 'selectors/general';
import { goToItem as goToItemAction } from '../../ManageServices.saga';
import ResourcesListItem from './ResourcesListItem';

const mapStateToProps = (state, ownProps) => {
  const { itemId } = selectRouteParams(state);
  return {
    ...ownProps,
    selectedResourceId: itemId,
  };
};

const mapDispatchToProps = {
  goToItem: goToItemAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { id } = stateProps;
  const { goToItem } = dispatchProps;
  return {
    ...stateProps,
    goToItem: goToItem.bind(null, id),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ResourcesListItem);
